import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { orgProduct } from '@/lib/queries/org-products'
import { OrgProductsPage } from '@/features/organizations/products'

const searchSchema = z.object({
  view: z.enum(['grid', 'list']).optional().catch('grid'),
  q: z.string().optional(),
  colorway: z.string().optional(),
  collection: z.string().optional(),
  gender: z.string().optional(),
  mainGroup: z.string().optional(),
  subGroup: z.string().optional(),
  category: z.string().optional(),
  attrs: z.record(z.string(), z.string()).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/org/$orgId/products/')({
  validateSearch: searchSchema,
  // The catalogue serves the image studio; without it, redirect home.
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.infiniteQuery({
        ...orgProduct.findManyByOrg(params.orgId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...orgProduct.findFilterOptions(params.orgId),
        staleTime: 'static',
      }),
    ])
  },
  component: OrgProductsPage,
})
